export const map = (x: number, a: number, b: number, c: number, d: number): number => ((x - a) * (d - c)) / (b - a) + c;
export const lerp = (a: number, b: number, n: number): number => (1 - n) * a + n * b;
export const clamp = (num: number, min: number, max: number): number => (num <= min ? min : num >= max ? max : num);
export const getMousePos = (e: MouseEvent, client: true): object => ({
    x: client ? e.clientX : e.pageX,
    y: client ? e.clientY : e.pageY,
});

export const zeroPad = (num: number, places: number) => String(num).padStart(places, '0')